import * as React from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17.051, height: 17, viewBox: "0 0 17.051 17", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", stroke: "rgba(0,0,0,0)", d: "M15.566.5a.94.94 0 0 0-.657.289L8.521 7.177 2.134.79a.94.94 0 1 0-1.33 1.33l6.388 6.388-6.388 6.387a.94.94 0 1 0 1.33 1.33l6.388-6.388 6.388 6.388a.94.94 0 1 0 1.33-1.33L9.852 8.507l6.387-6.388A.94.94 0 0 0 15.566.5Z" }));
export default SvgClose;
